import { SVGProps } from 'react';
import { LogoCompact } from '../images';

export const WeaveLogo = (props: SVGProps<SVGSVGElement>) => {
  return <LogoCompact {...props} />;
};
